import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

const HeroSwiper = () => {
  const prefersReducedMotion =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const autoplayConfig = prefersReducedMotion
    ? false
    : {
        delay: 2000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      };

  const swiperBreakpoints = {
    768: {
      slidesPerView: 2,
      spaceBetween: 12,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
  };

  const images = [4, 2, 1, 3, 5, 7, 6];

  return (
    <>
      <div className="block md:hidden w-full px-4">
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          loop={true}
          speed={800}
          autoplay={autoplayConfig}
          modules={[Autoplay]}
          className="w-full h-[300px]"
          aria-roledescription="carousel"
          aria-label="شريط صور إنجازات للموبايل"
        >
          {images.map((num) => (
            <SwiperSlide key={num}>
              <div className="w-full h-full overflow-hidden shadow-md bg-backgroundSwiper flex items-center justify-center rounded-lg">
                <img
                  src={`/images/${num}.png`}
                  alt={`Slide ${num}`}
                  className="w-full h-full object-contain object-center"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="hidden md:block w-full relative">
        {/* الصورة العلوية */}
        <img
          src="/images/e4.png"
          alt="Top Decoration"
          className="absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 top-[-15px]"
          loading="lazy"
          decoding="async"
          aria-hidden="true"
        />
        <Swiper
          slidesPerView={4}
          spaceBetween={10}
          loop={true}
          speed={5000}
          autoplay={autoplayConfig}
          freeMode={true}
          freeModeMomentum={true}
          breakpoints={swiperBreakpoints}
          modules={[Autoplay]}
          className="w-full h-[420px] lg:h-[525px]"
          aria-roledescription="carousel"
          aria-label="شريط صور إنجازات"
        >
          {images.map((num) => (
            <SwiperSlide key={num}>
              <div className="w-full h-full overflow-hidden shadow-lg bg-backgroundSwiper flex items-end justify-center">
                <img
                  src={`/images/${num}.png`}
                  alt={`Slide ${num}`}
                  className="max-h-full w-auto object-contain object-bottom"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* الصورة السفلية */}
        <img
          src="/images/e4.png"
          alt="Bottom Decoration"
          className="absolute left-1/2 transform -translate-x-1/2 translate-y-1/2 z-10 bottom-[-15px]"
          loading="lazy"
          decoding="async"
          aria-hidden="true"
        />
      </div>
    </>
  );
};

export default HeroSwiper;
